/**
 * Utility helpers for Tab Navigation.
 * This file contains shared pure helpers used by multiple screens, services, or wrappers.
 */
export interface TabNavigationState<T extends string> {
  activeIndex: number;
  canGoBack: boolean;
  canGoNext: boolean;
  previousTab: T | null;
  nextTab: T | null;
}

export function getTabNavigationState<T extends string>(tabs: readonly T[], activeTab: T): TabNavigationState<T> {
  const activeIndex = tabs.indexOf(activeTab);
  const previousTab = activeIndex > 0 ? tabs[activeIndex - 1] : null;
  const nextTab = activeIndex >= 0 && activeIndex < tabs.length - 1 ? tabs[activeIndex + 1] : null;

  return {
    activeIndex,
    canGoBack: previousTab !== null,
    canGoNext: nextTab !== null,
    previousTab,
    nextTab
  };
}
